module.exports = __webpack_public_path__ + "static/media/bookLoading.53e84026.gif";